import { render, staticRenderFns } from "./JSuperQuery.vue?vue&type=template&id=13f0e0dc&scoped=true&"
import script from "./JSuperQuery.vue?vue&type=script&lang=js&"
export * from "./JSuperQuery.vue?vue&type=script&lang=js&"
import style0 from "./JSuperQuery.vue?vue&type=style&index=0&id=13f0e0dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f0e0dc",
  null
  
)

export default component.exports